import { EP_PREFIX } from '../experimentConstants';

export const getModalKey = (daysLeftInTrial?: number | null) => {
	if (typeof daysLeftInTrial === 'number') {
		if (daysLeftInTrial <= 3) {
			return `${EP_PREFIX}${daysLeftInTrial}`;
		} else if (daysLeftInTrial <= 7) {
			return `${EP_PREFIX}7`;
		}
	}
	return '';
};
